import { Injectable } from '@angular/core';
import { JwtHelperService } from "@auth0/angular-jwt";

@Injectable({
  providedIn: 'root'
})
export class JwtService {
  private _helper = new JwtHelperService();

  constructor() { }

  public set _base64Token(token: string){
    localStorage.setItem('token', token);
  }

  public get base64Token(): string | undefined {
    const base64Token: string | null = localStorage.getItem('token');
    if(base64Token == null) {
      return undefined; 
    }
    return base64Token;
  }

  public get token(): any{
    return this._helper.decodeToken(this.base64Token);
  }

  public get isTokenExpired(): boolean{
    return this._helper.isTokenExpired(this.base64Token, 5);
  }

  public removeToken(){
    localStorage.removeItem('token');
  }
}
